// Constants to be used as content for the associated component's `console.error` or `console.warn`.
export const MESSAGES = {
    INVALID_ACTIVE_ITEM: 'Active item for Toggle Button is not a valid react element. Please provide the id of a valid react element.',
};
